import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Button, Avatar, Chip, Typography } from "@mui/material";
// import {Typograhy, ToggleButton, ToggleButtonGroup} from "@mui/material";
import axios from "axios";
import BASE_API_URL from "../../apis/index";
import styled from "styled-components";
import { Link } from "react-router-dom";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  // const [userStatus, setUserStatus] = useState("All");
  const [totalPages, setTotalPages] = useState(1);

  const placeholderUser = "/Images/user_profile_placeholder.png";

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(
          // `${BASE_API_URL}/api/admin/users?page=${page}&limit=${limit}&status=${userStatus}`,
          `${BASE_API_URL}/api/admin/users?page=${page}&limit=${limit}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setUsers(res.data.users);
        setTotalPages(res.data.totalPages);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, [page, limit]);

  // useEffect(() => setPage(1), [userStatus]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) setPage(newPage);
  };

  return (
    <Wrapper className="p-2">

      <Typography variant="h5" mb={2}>Registered Users</Typography>
      {/* <div className="mb-3 d-flex justify-content-between align-items-end">
        <div>

          <ToggleButtonGroup
            value={userStatus}
            exclusive
            onChange={(e, s) => s && setUserStatus(s)}
            size="small"
            className="StatusToggles"
          >
            <ToggleButton value="All">All</ToggleButton>
            <ToggleButton value="Active">Active</ToggleButton>
            <ToggleButton value="Inactive">Inactive</ToggleButton>
            <ToggleButton value="Blocked">Blocked</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div> */}

      {/* ✅ Users Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow className="bg-dark text-white">
              <TableCell><b className="text-white">User</b></TableCell>
              <TableCell><b className="text-white">Company</b></TableCell>
              <TableCell><b className="text-white">Designation</b></TableCell>
              <TableCell><b className="text-white">Email</b></TableCell>
              <TableCell><b className="text-white">Mobile</b></TableCell>
              {/* <TableCell><b className="text-white">Status</b></TableCell> */}
              <TableCell><b className="text-white">Registered Date</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users.length ? users.map((user) => (
              <TableRow key={user.id}>
                <TableCell className="compName">
                  <Link to={`/admin/user-details?userId=${user.id}`} className="text-decoration-none">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Avatar
                        src={
                          user.profile_image
                            ? `${BASE_API_URL}/uploads/user_profile_images/${user.profile_image}`
                            : placeholderUser
                        }
                        alt={user.name}
                      />
                      <span>{user.name}</span>
                      {user.role === "admin" && <Chip label="Admin" size="small" color="primary" variant="outlined" />}
                    </div>
                  </Link>
                </TableCell>

                <TableCell>{user.company || "-"}</TableCell>
                <TableCell>{user.designation || "-"}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.mobile}</TableCell>
                {/* <TableCell>{user.status}</TableCell> */}

                <TableCell>
                  {user.registered_date
                    ? new Date(user.registered_date).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : "-"}
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell colSpan={7} align="center">No users found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ✅ Pagination */}
      <Box mt={2} display="flex" justifyContent="center" gap={1}>
        <Button variant="outlined" disabled={page === 1} onClick={() => handlePageChange(page - 1)}>Prev</Button>

        {[...Array(totalPages)].map((_, i) => (
          <Button
            key={i}
            variant={page === i + 1 ? "contained" : "outlined"}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </Button>
        ))}

        <Button variant="outlined" disabled={page === totalPages} onClick={() => handlePageChange(page + 1)}>Next</Button>
      </Box>

    </Wrapper>
  );
};

export default AdminUsers;

const Wrapper = styled.div`
.StatusToggles {
  button {
    padding: 5px 20px;
  }
  button.Mui-selected {
    background: var(--secondary-color);
    color: white;
  }
}
tbody .compName {
  background: #f2f2f2;
  &:hover a span {
    color: orange;
  }
}
tbody a {
  color: brown;
  &:hover { color: orange; }
}
`;
